import { render } from "./PhoneColor.vue?vue&type=template&id=4bec20ba"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/PhoneColor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bec20ba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bec20ba', __exports__)) {
    api.reload('4bec20ba', __exports__)
  }
  
  module.hot.accept("./PhoneColor.vue?vue&type=template&id=4bec20ba", () => {
    api.rerender('4bec20ba', render)
  })

}


export default __exports__